module.exports = __webpack_public_path__ + "img/empty.2b0d225d.png";